module.exports = __webpack_public_path__ + "static/media/id.d3091dea.svg";